import { Stack, styled } from '@mui/material';

export const CarouselWrapper = styled(Stack)`
  overflow-x: scroll;
  padding-bottom: 1rem;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;
